export const formatCentsToDollars = (cents: number) => {
  // Always include decimal places
  return cents > 0 ? `$${(cents / 100).toFixed(2)}` : null;
};

export const formatCentsToDollarsWithPlusSign = (cents: number) => {
  return cents > 0 ? `+ ${formatCentsToDollars(cents)}` : null;
};
